import AdminApis from "apis/AdminApis";
import UserApi from "apis/UserApi";
import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [authToken, setAuthToken] = useState(() => {
    const token = localStorage.getItem("token");
    return token ;
  });

  const login = (userData) => {
    setUser(userData); // Save user data
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const storeToken = async (token) => {
    setAuthToken(token);
    UserApi.setAuthToken(token)
    AdminApis.setAuthToken(token)
    const responseAPI = await  UserApi.getUserDetails()
    setUser(responseAPI?.data?.data?.[0])
    localStorage.setItem("token", token);
    localStorage.setItem("membershipPaid", responseAPI?.data?.data?.[0]?.membershipPaid);
    localStorage.setItem("user", JSON.stringify(responseAPI?.data?.data?.[0]));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, authToken,login, logout ,storeToken}}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);
